import { RFIconProps } from "../types";

export default function FinishedIcon(props: RFIconProps) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			className={props.className || "w-6 h-6"}
		>
			<path
				d="M1 13.9985V4.04463C1.04062 3.19941 1.41456 2.40474 2.03991 1.83467C2.66526 1.2646 3.49105 0.9656 4.33641 1.00315H13.6636C14.509 0.9656 15.3347 1.2646 15.9601 1.83467C16.5854 2.40474 16.9594 3.19941 17 4.04463V13.9985C16.9594 14.8438 16.5854 15.6384 15.9601 16.2085C15.3347 16.7786 14.509 17.0776 13.6636 17.04H4.33641C3.49105 17.0776 2.66526 16.7786 2.03991 16.2085C1.41456 15.6384 1.04062 14.8438 1 13.9985Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.93091 9.5467L7.99542 12.072L12.0692 7.44531"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
